import React from "react";
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";


interface Props{
  onSelect(): void;
}

const getNavLinkClass = ({ isActive }: { isActive: boolean }) =>
  `nav-link ${isActive ? "active" : "text-dark"}`;

const SettingsMenu: React.FC<Props> = ({onSelect}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (onSelect) onSelect();
  };
  return (
    <ul className="nav nav-pills flex-column mb-auto">
      <li className="nav-item">
        <NavLink to="/settings/account" className={getNavLinkClass} aria-current="page" onClick={handleClick}>
        {t('account')}
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/settings/billing" className={getNavLinkClass} onClick={handleClick}>
        {t('billing')}
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/settings/notification" className={getNavLinkClass} onClick={handleClick}>
        {t('notification')}
        </NavLink>
      </li>      
      <li className="nav-item">
        <NavLink to="/settings/invoice#invoiceNumber" className={getNavLinkClass} onClick={handleClick}>
          {t('invoiceSettings')}
        </NavLink>
      </li>      
    </ul>
  );
};

export default SettingsMenu;
